import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { EndOfDayFinancialInfoRequest, EndOfDayFinancialInfoViewModel, KeepQuoteOpenRequest } from '../models/end-of-days';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';
import { FortisBaseResponse } from '../models/clinics/fortis/fortis-base-response';
import { FortisBatchReportModel } from '../models/payments/fortis/fortis-batch-report-model';

@Injectable({
  providedIn: 'root'
})
export class EndOfDayDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  generateReportAsync(endOfDayId: number, timeout?: Promise<any>): Promise<FileResponse> {
    return this.httpClient.getFileAsync('EndOfDays/Report', { endOfDayId: endOfDayId }, timeout);
  }

  getFinancialInfoAsync(clinicId: number, closingDate: string, timeout?: Promise<any>): Promise<EndOfDayFinancialInfoViewModel> {
    const request: EndOfDayFinancialInfoRequest = { clinicId: clinicId, closingDate: closingDate };
    return this.httpClient.getJsonAsync<EndOfDayFinancialInfoViewModel>('EndOfDays/FinancialInfo', request, timeout);
  }

  keepQuoteOpenAsync(endOfDayId: number, salesOrderId: number, timeout: Promise<any>): Promise<any> {
    const request: KeepQuoteOpenRequest = { endOfDayId: endOfDayId, salesOrderId: salesOrderId };
    return this.httpClient.postJsonAsync('EndOfDays/KeepQuoteOpen', request, timeout);
  }

  completeEndOfDayAsync(endOfDayId: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('EndOfDays/CompleteEndOfDay', endOfDayId, timeout);
  }

  checkEndOfDayExistsAsync(clinicId: number, closingDate: string, timeout?: Promise<any>): Promise<boolean> {
    const data = { clinicId: clinicId, closingDate: closingDate };
    return this.httpClient.getJsonAsync<boolean>('EndOfDays/CheckEndOfDayExists', data, timeout, false);
  }

  checkHasUnhandledQuotesAsync(endOfDayId: number, timeout?: Promise<any>): Promise<boolean> {
    return this.httpClient.getJsonAsync<boolean>('EndOfDays/CheckHasUnhandledQuotes', {endOfDayId}, timeout, false);
  }

  registerPaymentFormAsync(depositsIds: number[], cancellation: Promise<any>): Promise<any> {
    const request = { DepositId: depositsIds };
    return this.httpClient.getJsonAsync('EndOfDays/RegisterPayment', request, cancellation);
  }

  saveEndOfDayFortisReportAsync(clinicId: number, endOfDayId: number, cancellation: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('EndOfDays/saveEndOfDayFortisReport', {clinicId,endOfDayId}, cancellation);
  }

  generateFortisBatchReportAsync(endOfDayId: number, timeout?: Promise<any>): Promise<FortisBaseResponse<FortisBatchReportModel>> {
    return this.httpClient.getJsonAsync('EndOfDays/generateFortisBatchReport', { endOfDayId: endOfDayId });
  }

  reopenEndOfDayAsync(endOfDayId: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('EndOfDays/ReopenEndOfDay', endOfDayId, timeout);
  }
  checkCanCreatePastEndOfDayAsync(clinicId: number, closingDate: string, timeout?: Promise<any>): Promise<{canCreate: boolean, errorCode?: string, errorMessage?: string, blockingDate?: string}> {
    const data = { clinicId: clinicId, closingDate: closingDate };
    return this.httpClient.getJsonAsync<{canCreate: boolean, errorCode?: string, errorMessage?: string, blockingDate?: string}>('EndOfDays/CheckCanCreatePastEndOfDay', data, timeout, false);
  }
}
